import Router from 'vue-router';
import LoginPage from './LoginPage.vue'
import Dashboard from './Dashboard.vue'
import Admin from './Admin.vue'
const router = new Router({
    routes: [
      {
        path: '/',
        redirect: '/login'
      },
      {
        path: '/login',
        name: 'Login',
        component: LoginPage
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/admin',
        name: 'Admin',
        component: Admin,
        meta: {
          requiresAuth: true
        }
      }
    ]
  });
  router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isAuthenticated = localStorage.getItem('token'); // 检查用户登录状态
    if (requiresAuth && !isAuthenticated) {
      next('/login');
    } else {
      next()
    }
  });

  export { router }